import BoxOrViolinPlot from "./box-or-violin-plot";
import "chartjs-chart-box-and-violin-plot/build/Chart.BoxPlot.js";

class BoxPlot extends BoxOrViolinPlot {
    constructor(props) {
        super(props);
    }
}

export default BoxPlot;
